module.exports = __webpack_public_path__ + "static/security-fd254576e3a9a63be7c8ccd7e3a54120.jpg";